import React from 'react';
import '../../styles/services.css';
import { motion } from 'framer-motion';

const Maintenance = () => (
  <motion.div 
    className="industry-page" 
    initial={{ opacity: 0 }} 
    animate={{ opacity: 1 }} 
    transition={{ duration: 0.8 }}
  >
    <div className="industry-content">
      <h1>Maintenance & Support</h1>
      <p>
        Ensure your software remains up-to-date and fully functional with our ongoing maintenance and support services. 
        We provide timely updates, bug fixes, and technical assistance to keep your applications running smoothly.
      </p>
      <ul className="bullet-points">
        <li>🔄 Regular updates and enhancements</li>
        <li>🛠️ Quick bug fixing and issue resolution</li>
        <li>📞 24/7 technical support</li>
        <li>⚡ Performance monitoring and optimization</li>
        <li>🛡️ Security patches and compliance</li>
      </ul>
    </div>
  </motion.div>
);

export default Maintenance;
